import React from 'react'
import Layout from './Layout'
import Main from './screens/Main'

function App() {
  return (
    <Layout>
      <Main />
    </Layout>
  )
}

export default App
